export const applicationSelector = (state) => state.application